import { TOGGLE_TEACHER_MODE } from "../actions/action_types";
import produce from "immer";
const teacherModeReducer = produce((state, action) => {
  if (action.type === TOGGLE_TEACHER_MODE) {
    state.teacherMode = !state.teacherMode;
    return;
  } else {
    return;
  }
});
export default teacherModeReducer;